/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdatePlaceholderInput = {
    id?: string | null | undefined;
    name?: string | null | undefined;
    projectId?: string | null | undefined;
    projectGroupId?: string | null | undefined;
    roleId?: string | null | undefined;
    departmentId?: string | null | undefined;
    teamIds?: Array<string | null> | null | undefined;
    skillPlaceholders?: Array<SkillPlaceholderInputType | null> | null | undefined;
    labelIds?: Array<string | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type SkillPlaceholderInputType = {
    placeholderId?: string | null | undefined;
    skillId?: string | null | undefined;
    skillLevelId?: string | null | undefined;
};
export type updatePlaceholderMutationVariables = {
    input: UpdatePlaceholderInput;
};
export type updatePlaceholderMutationResponse = {
    readonly updatePlaceholder: {
        readonly placeholder: {
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly role: {
                    readonly id: string;
                    readonly name: string | null;
                } | null;
                readonly project: {
                    readonly id: string;
                } | null;
                readonly projectGroupId: string | null;
                readonly skills: {
                    readonly edges: ReadonlyArray<{
                        readonly node: {
                            readonly id: string;
                        } | null;
                    } | null> | null;
                } | null;
                readonly skillPlaceholders: ReadonlyArray<{
                    readonly skill: {
                        readonly id: string;
                    } | null;
                    readonly level: {
                        readonly id: string;
                    } | null;
                } | null> | null;
                readonly departmentId: string | null;
                readonly teamPlaceholders: ReadonlyArray<{
                    readonly teamId: string | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type updatePlaceholderMutation = {
    readonly response: updatePlaceholderMutationResponse;
    readonly variables: updatePlaceholderMutationVariables;
};



/*
mutation updatePlaceholderMutation(
  $input: UpdatePlaceholderInput!
) {
  updatePlaceholder(input: $input) {
    placeholder {
      node {
        id
        name
        role {
          id
          name
        }
        project {
          id
        }
        projectGroupId
        skills {
          edges {
            node {
              id
            }
          }
        }
        skillPlaceholders {
          skill {
            id
          }
          level {
            id
          }
          id
        }
        departmentId
        teamPlaceholders {
          teamId
          id
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdatePlaceholderInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = [
  (v2/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectType",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillTypeConnection",
  "kind": "LinkedField",
  "name": "skills",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SkillTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Skill",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v5/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Skill",
  "kind": "LinkedField",
  "name": "skill",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillLevel",
  "kind": "LinkedField",
  "name": "level",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "departmentId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updatePlaceholderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdatePlaceholderPayload",
        "kind": "LinkedField",
        "name": "updatePlaceholder",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PlaceholderTypeEdge",
            "kind": "LinkedField",
            "name": "placeholder",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Placeholder",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SkillPlaceholder",
                    "kind": "LinkedField",
                    "name": "skillPlaceholders",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamPlaceholder",
                    "kind": "LinkedField",
                    "name": "teamPlaceholders",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updatePlaceholderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdatePlaceholderPayload",
        "kind": "LinkedField",
        "name": "updatePlaceholder",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PlaceholderTypeEdge",
            "kind": "LinkedField",
            "name": "placeholder",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Placeholder",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SkillPlaceholder",
                    "kind": "LinkedField",
                    "name": "skillPlaceholders",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamPlaceholder",
                    "kind": "LinkedField",
                    "name": "teamPlaceholders",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updatePlaceholderMutation",
    "operationKind": "mutation",
    "text": "mutation updatePlaceholderMutation(\n  $input: UpdatePlaceholderInput!\n) {\n  updatePlaceholder(input: $input) {\n    placeholder {\n      node {\n        id\n        name\n        role {\n          id\n          name\n        }\n        project {\n          id\n        }\n        projectGroupId\n        skills {\n          edges {\n            node {\n              id\n            }\n          }\n        }\n        skillPlaceholders {\n          skill {\n            id\n          }\n          level {\n            id\n          }\n          id\n        }\n        departmentId\n        teamPlaceholders {\n          teamId\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '6c283658a3e198630a0cd96f88006d21';
export default node;
